export enum roomTypes {
  PARTICIPANT_CAM_HIDDEN = 'PARTICIPANT_CAM_HIDDEN',
  PARTICIPANT_CAM_VISIBLE = 'PARTICIPANT_CAM_VISIBLE',
  PARTICIPANT_CONNECTED = 'PARTICIPANT_CONNECTED',
  PARTICIPANT_DISCONNECTED = 'PARTICIPANT_DISCONNECTED',
  PARTICIPANT_INFORMATION_ADDED = 'PARTICIPANT_INFORMATION_ADDED',
  PARTICIPANT_INFORMATION_ERROR = 'PARTICIPANT_INFORMATION_ERROR',
  PARTICIPANT_MUTED = 'PARTICIPANT_MUTED',
  PARTICIPANT_UNMUTED = 'PARTICIPANT_UNMUTED',
  PRESENTER_CONNECTED = 'PRESENTER_CONNECTED',
  PRESENTER_DISCONNECTED = 'PRESENTER_DISCONNECTED',
  REMOVE_DIALED_IN_PRESENTER = 'REMOVE_DIALED_IN_PRESENTER',
  SET_DIALED_IN_PRESENTER = 'SET_DIALED_IN_PRESENTER',
  SET_PARTICIPANT_INFORMATION = 'SET_PARTICIPANT_INFORMATION',
  SET_MISSING_PARTICIPANT_INFORMATION = 'SET_MISSING_PARTICIPANT_INFORMATION',
  MISSING_PARTICIPANT_ADDED = 'MISSING_PARTICIPANT_ADDED',
  TWILIO_RECONNECTED = 'TWILIO_RECONNECTED',
  TWILIO_RECONNECTING = 'TWILIO_RECONNECTING',
  TWILIO_ROOM_DISCONNECTED = 'TWILIO_ROOM_DISCONNECTED',
  TEAR_DOWN_ROOM = 'TEAR_DOWN_ROOM',
  TEAR_DOWN_ROOM_ERROR = 'TEAR_DOWN_ROOM_ERROR',
  TEAR_DOWN_ROOM_SUCCESS = 'TEAR_DOWN_ROOM_SUCCESS',
  ADD_PARTICIPANT_TO_LOOKUP = 'ADD_PARTICIPANT_TO_LOOKUP',
  REMOVE_PARTICIPANT_FROM_LOOKUP = 'REMOVE_PARTICIPANT_FROM_LOOKUP',
  SET_FOCUS = 'SET_FOCUS',
  SET_SCREENSHARE_FOCUS = 'SET_SCREENSHARE_FOCUS',
  REMOTE_PARTICIPANTS_ADDED = 'REMOTE_PARTICIPANTS_ADDED',
  DISCONNECT_USER = 'DISCONNECT_USER',
  DISCONNECT_USER_SUCCESS = 'DISCONNECT_USER_SUCCESS',
  SET_MEDIA_TYPE_STATE = 'SET_MEDIA_TYPE_STATE',
  NETWORK_QUALITY_CHANGE = 'NETWORK_QUALITY_CHANGE',
  UNSET_FOCUS = 'UNSET_FOCUS',
  SET_PRESENTER_COUNT = 'SET_PRESENTER_COUNT',
  SET_MESSAGE_CODE = 'SET_MESSAGE_CODE',
  SET_DEVICE_PERMISSIONS = 'SET_DEVICE_PERMISSIONS',
  EXTEND_USER_SESSION_SUCCESS = 'EXTEND_USER_SESSION_SUCCESS',
  EXTEND_USER_SESSION_FAILED = 'EXTEND_USER_SESSION_FAILED'
}
